import { Route, Routes as Router } from "react-router-dom";
import { ComingSoon } from "./components/ComingSoon";
import { EmployeeTags } from "./pages/employee-tags/employee-tags";
import { Employees } from "./pages/employees/Employees";
import { Home } from "./pages/home/Home";
import { Onboarding } from "./pages/onboarding/Onboarding";
import { Plans } from "./pages/plans/Plans";
import { Billing } from "./pages/billing/Billing";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { InvoiceDetails } from "./pages/billing/InvoiceDetails";
import { FloatManagement } from "./pages/billing/FloatManagement";
import { useData } from "./utils/useData";
import { EmployeeTag } from "./models";

export const AuthenticatedRoutes = () => {
  const { getBooleanFlag, getPermission } = useKindeAuth();
  const { employer } = useData();

  const displayBilling = !employer.isLoading
    && employer.data
    && !employer.data.paymentOptions.isFree
    && employer.data.tags.indexOf(EmployeeTag.PILOT) === -1;

  return (
    <Router>
      <Route path="/" Component={Home} />
      <Route path="/employees" Component={Employees} />
      <Route path="/reporting" Component={ComingSoon} />
      <Route path="/plans" Component={Plans} />
      {displayBilling &&
        <>
          {getBooleanFlag("invoicing") === true || getPermission("admin_access")?.isGranted === true
            ? <>
              <Route path="/billing" Component={Billing} />
              <Route path="/invoices/:invoiceId" element={<InvoiceDetails />} />
            </>
            : <Route path="/billing" Component={ComingSoon} />}
        </>
      }
      {getBooleanFlag("float_management") === true || getPermission("admin_access")?.isGranted === true
        ? <Route path="/float-management" Component={FloatManagement} />
        : <Route path="/float-management" Component={ComingSoon} />}
      <Route path="/employee-tags" Component={EmployeeTags} />
      <Route path="/account" Component={ComingSoon} />
    </Router>
  );
};

export const UnAuthenticatedRoutes = () => {
  return (
    <Router>
      <Route path="/onboarding" Component={Onboarding} />
    </Router>
  );
};
